import axios from 'axios';
import { message } from 'antd';
import {
  CUSTOMER_API
} from '../../../constants/API';
import {
  GET_CUSTOMER_ITEM_LOADING,
  GET_CUSTOMER_ITEM
} from '../types';

function getCustomerItem(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_CUSTOMER_ITEM,
      loadingCustomerItem: true,
      customerItem: null
    });
    try {
      const accessToken = await localStorage.getItem('accessToken');
      const customerItemResponse = await axios.get(
        `${CUSTOMER_API}/${id}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      dispatch({
        type: GET_CUSTOMER_ITEM,
        loadingCustomerItem: false,
        customerItem: customerItemResponse.data
      });
    } catch (e) {
      console.log(e);
      message.error(String(e));
      dispatch({
        type: GET_CUSTOMER_ITEM_LOADING,
        loadingCustomerItem: false
      });
    }
  };
}
export default getCustomerItem;
